<template>
<div class="c-list-wrapper">
  <h4>{{ cityName }}の学校一覧</h4>
  <ul>
    <li v-for="( item ) in items" :key="item.id" @click="select(item)" :class="item.name === value.name ? 'c-list-item selected' : 'c-list-item'">{{item.name}}</li>
  </ul>
  <div class="c-button-wrapper" v-if="containsHits">
    <button class="round-button submit-button" @click="navigateToPropertyList">
      {{ cityName }}の物件一覧はこちら
      <img src="@/assets/arrow_white.png"/>
    </button>
  </div>
</div>

</template>

<script>
export default {
  name: 'SchoolDistrictsListBody',
  mixins: [],
  props: ['items', 'cityName', 'cityCode', 'prefCode', 'value', 'containsHits'],
  components: {},
  data() {
    return {
      selected: this.items[0].id,
    };
  },
  computed: {},
  methods: {
    navigateToPropertyList() {
      this.$router.push(`/kodate/area/${this.prefCode}/${this.cityCode}/`);
    },
    select(item) {
      if (item.name === this.value.name) {
        return;
      }
      this.$emit('input', item);
    },
  },
};

</script>

<style scoped lang="scss">
@import "@/assets/style/parts_responsive.scss";
$tablet-width: 640px;
$desktop-width: 999px;

.c-list-item {
  display: flex;
  align-items: center;
  width: 100%;
  font-size: 16px;
  border: 1px solid #EFEFEF;
  border-radius: 40px;
  padding: 0px 20px;
  margin: 6px 0;
  height: 44px;
  cursor: pointer;

  &.selected {
    background-color: rgba(232,53,50,.2);
  }

}

.c-list-item:hover {
  background-color: rgba(232,53,50,.2);
}

h4 {
  font-weight: bold;
  text-align: center;
  margin: 8px 0 22px 0;
  font-size: 16px;
}

ul {
  max-height: 440px;
  overflow-y: scroll;
  margin: 16px 0px;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none;  /* IE 10+ */
}

ul::-webkit-scrollbar {
  display: none;
  width: 0;
  height: 0;
}

.c-button-wrapper {
  display: flex;
  justify-content: center;

  .round-button {
    height: 44px;
    font-size: 16px;
    min-width: 276px;
    padding-left: 22px;
    padding-right: 22px;
    display: inline-block;
    width: initial;

    img {
      margin-left: 8px;
    }

  }

}

@media (min-width: $tablet-width) {
  ul {
    margin: 16px 20px;
  }
  h4 {
    font-size: 18px;
  }

}

@media (min-width: $desktop-width) {
  .c-list-wrapper {
    padding: 0 20px;
  }
  ul {
    margin: 16px 20px;
  }
  h4 {
    text-align: left;
    font-size: 18px;
  }

}
</style>
